import "../layouts/default";

import Vue from "vue";
import VueI18n from "vue-i18n";

// import components
import Comparison from "./../components/vue/Comparison.vue";

// vue config
const devMode = process.env.NODE_ENV === "development";
Vue.config.devtools = devMode;
Vue.config.debug = devMode;
Vue.config.silent = !devMode;
Vue.config.productionTip = devMode;

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: document.querySelector("html").getAttribute("lang"),
    fallbackLocale: "sk",
    messages: {
        sk: require("../locale/sk.json"),
    },
});

window.$_comparison = new Vue({
    i18n,
    render: (h) => h(Comparison),
}).$mount("#comparison");

Event.on("Comparison.countUpdated", (data) => {
    document.querySelector(".js-compare-badge").innerHTML = data.count;
});
